export const FETCH_TICKET_QUEUE_LIST = "FETCH_TICKET_QUEUE_LIST";
export const CREATE_TICKET_QUEUE = "CREATE_TICKET_QUEUE";
export const UPDATE_TICKET_QUEUE = "UPDATE_TICKET_QUEUE";
